import { useEffect, useState } from "react";

function FlashCountdown({ endTime }: { endTime?: string }) {
  const [time, setTime] = useState("");

  useEffect(() => {
    if (!endTime) return;

    const timer = setInterval(() => {
      const diff =
        new Date(endTime).getTime() - new Date().getTime();

      if (diff <= 0) {
        setTime("00:00:00");
        clearInterval(timer);
        return;
      }

      const h = Math.floor(diff / 3600000);
      const m = Math.floor((diff % 3600000) / 60000);
      const s = Math.floor((diff % 60000) / 1000);

      setTime(
        `${String(h).padStart(2, "0")}:${String(m).padStart(
          2,
          "0"
        )}:${String(s).padStart(2, "0")}`
      );
    }, 1000);

    return () => clearInterval(timer);
  }, [endTime]);

  return <div className="flash-countdown">⏱ {time}</div>;
}


export default FlashCountdown;